import createjs from 'preload-js'
import injector from 'vue-inject'

export default class ContentLoader {
  static DATA = {}

  static initialize (onProgress, onComplete) {
    this.onProgressCallback = onProgress || function () {
      //
    }
    this.onCompleteCallback = onComplete || function () {
      //
    }
    this.loadData()
  }

  static loadData () {
    this.queue = new createjs.LoadQueue(true)
    this.queue.loadFile({id: 'home_hero', src: process.env.API_URL + 'home/hero.json', crossOrigin: true}, false)
    this.queue.loadFile({id: 'tracks', src: process.env.API_URL + 'tracks.json', crossOrigin: true}, false)
    this.queue.loadFile({id: 'playlists', src: process.env.API_URL + 'playlists.json', crossOrigin: true}, false)
    this.queue.loadFile({id: 'configs', src: process.env.API_URL + 'configs.json', crossOrigin: true}, false)
    this.queue.loadFile({id: 'images', src: '/static/data/images.json', crossOrigin: true}, false)

    this.queue.on('progress', (event) => {
      this.onProgressCallback(event.progress * 0.2)
    })

    this.queue.on('fileload', (event) => {
      this.DATA[event.item.id] = event.result
    })

    this.queue.on('complete', () => {
      this.loadImages()
    })
    this.queue.load()
  }

  static loadImages () {
    this.queueImages = new createjs.LoadQueue(true)

    if (process.env.NODE_ENV !== 'development') {
      for (let s in this.DATA.images) {
        this.queueImages.loadFile({id: s, src: this.DATA.images[s]}, false)
      }

      for (let s in this.DATA.home_hero) {
        let hero = this.DATA.home_hero[s]
        if (hero.background) {
          this.queueImages.loadFile({id: 'hero_' + hero.id, src: hero.background}, false)
        }
      }
    }

    this.queueImages.on('progress', (event) => {
      this.onProgressCallback(0.7 + (event.progress * 0.3))
    })

    this.queueImages.on('complete', () => {
      this.onCompleteCallback()
      injector.service('DATA', () => {
        return this.DATA
      })
    })

    this.queueImages.load()
  }
}



// WEBPACK FOOTER //
// ./src/core/ContentLoader.js